var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbp-accordion-content-cell-total-time"},[_c('span',[_vm._v("and tracked time")]),_vm._v(" "),(!_vm.isEdit)?_c('span',[_c('i',{staticClass:"bbp-icon-clock bbp-accordion-content-item-time__icon"}),_vm._v("\n    "+_vm._s(_vm.totalTime)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486dcba8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPTable/BBPAccordionCell/BBPAccordionContentCellTotalTime.vue
// module id = null
// module chunks = 